import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";
import Navbar from "./Components/Navbar";
import Main from "./Screens/Main";
import View from "./Screens/View";

import { useState, useEffect } from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import VerifyEmail from "./Screens/VerifyEmail";
import TermsOfUse from "./Screens/TermsOfUse";
import ApiDocs from "./Screens/ApiDocs";
import FaqScreen from "./Screens/FaqScreen";
import DataPrivacy from "./Screens/DataPrivacy";
import Footer from "./Components/Footer";

const App = () => {
  const prefferedMode = localStorage.getItem('mode') || 'dark'; // Get the preferred mode from localStorage or default to dark
  const [mode, setMode] = useState(prefferedMode); // Initialize mode to dark

  useEffect(() => {
    document.title = "Share-a-Secret"; // Set the document title
  }
  , []);
  // Create the theme dynamically based on the current mode
  const theme = createTheme({
    palette: {
      mode: mode,
      primary: {
        main: '#D4AF37', // Gold color
      },
      secondary: {
        main: '#D1A7A1', // Soft pink color
      },
      ...(mode === 'dark'
        ? {
            background: { default: '#0B0F19', paper: '#131A2A' },
          }
        : {
            background: { default: '#F5F7FA', paper: '#FFFFFF' },
          }),
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      h2: { fontWeight: 800, letterSpacing: '-0.02em' },
      h3: { fontWeight: 800, letterSpacing: '-0.02em' },
      h4: { fontWeight: 700 },
      button: { textTransform: 'none', fontWeight: 600 },
    },
  });

  // Function to toggle between light and dark mode
  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'dark' ? 'light' : 'dark')); // Toggle mode
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Ensure the styles are applied globally */}
      <Router>
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar toggleTheme={toggleTheme}/>
                <Box component="main" sx={{ 
                  flexGrow: 1,
                  p: 1,
                  minHeight: '100vh',
                  bgcolor: 'background.default',
                  //border: "2px solid red",
                  mt:0
                }}>
                
                  {/* Content Area */}
                  <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<Main />} />
                    <Route path="/view/:secretId" element={<View />} />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route path="/terms-of-use" element={<TermsOfUse />} />
                    <Route path="/data-privacy" element={<DataPrivacy />} />
                    <Route path="/api/docs" element={<ApiDocs />} />
                    <Route path="/faq" element={<FaqScreen />} />
                  </Routes>
                </Box>
                <Footer />
            </Box>
          </Router>
    </ThemeProvider>
  );
};

export default App;
